<template>
    <div id="add-follow-up-dialog-component">
        <v-dialog v-model="is_add_edit_follow_dialog_open" max-width="600px">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-if="NoteTypeRelatable.ASSETS"
                    color="primary"
                    elevation="0"
                    rounded
                    v-bind="attrs"
                    @click="openPostAddFollowUpDialog"
                    v-on="on"
                >
                    <span class="white--text"><v-icon>mdi-plus</v-icon>{{ $t('add_follow_up_dialog_component.add_follow_up') }}</span>
                </v-btn>
            </template>

            <v-card>
                <v-card-title>
                    <span class="text-h5">
                        {{
                            isNew
                                ? $t('add_follow_up_dialog_component.add_a_follow_up')
                                : $t('add_follow_up_dialog_component.edit_a_follow_up')
                        }}
                    </span>
                </v-card-title>
                <v-card-text class="pb-0">
                    <v-select
                        v-model="tag_selected"
                        :disabled="!isNew"
                        :items="tags"
                        :label="$t('dialog_update_alert_component.type') + '*'"
                        :menu-props="{ bottom: true, offsetY: true }"
                        filled
                        item-text="label"
                        item-value="id_tag_referentiel"
                    />

                    <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        min-width="auto"
                        offset-y
                        transition="scale-transition"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="formatted_date"
                                :label="$t('global.date') + '*'"
                                filled
                                persistent-hint
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            />
                        </template>
                        <v-date-picker v-model="date" @input="menu = false"></v-date-picker>
                    </v-menu>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="is_add_edit_follow_dialog_open = false">{{ $t('global.cancel') }}</v-btn>
                    <v-btn :loading="adding_follow_up" color="primary" elevation="0" rounded @click="prepareAddEditFollowup">
                        <span class="white--text">{{ $t('global.validate') }}</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import AssetRepository from '@/repositories/AssetRepository'
import tagsReferentielService from '@/repositories/tagsReferentielRepository'
import { NoteTypeRelatable } from '@/models/INote'

export default {
    name: 'AddFollowUpDialogComponent',
    props: {
        asset: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            tags: [],
            tag_selected: null,
            is_add_edit_follow_dialog_open: false,
            date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
            menu: false,
            adding_follow_up: false,
            isNew: false,
            follow_up: {},
        }
    },
    mounted() {
        this.getFollowUpFilterTagsReferentielForClient()
    },
    computed: {
        formatted_date() {
            return this.formatDate(this.date)
        },
        NoteTypeRelatable() {
            return NoteTypeRelatable
        },
    },
    methods: {
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY')
        },
        prepareAddEditFollowup() {
            this.isNew ? this.postAddFollowup() : this.putUpdateFollowUp()
        },
        postAddFollowup() {
            this.isNew = true
            this.adding_follow_up = true
            AssetRepository.postAddFollowup(this.asset.id_asset, this.date, this.tag_selected.id_tag_referentiel)
                .then(() => {
                    this.is_add_edit_follow_dialog_open = false
                    this.showSnackbar('success', this.$t('dialog_manage_widget_component.add_success'))
                    this.$emit('added:follow-up')
                })
                .catch((error) => {
                    this.manageError(error)
                })
                .finally(() => {
                    this.adding_follow_up = false
                })
        },
        putUpdateFollowUp() {
            this.isNew = false
            AssetRepository.putUpdateFollowUp(
                this.asset.id_asset,
                this.follow_up.id_follow_up,
                this.date,
                this.tag_selected.id_tag_referentiel
            )
                .then(() => {
                    this.is_add_edit_follow_dialog_open = false
                    this.showSnackbar('success', this.$t('global.updated'))
                    this.$emit('updated:follow-up')
                })
                .catch((error) => {
                    this.manageError(error)
                })
                .finally(() => {
                    this.is_add_edit_follow_dialog_open = false
                })
        },
        getFollowUpFilterTagsReferentielForClient() {
            return tagsReferentielService
                .getFollowUpFilterTagsReferentielForClient()
                .then((success) => {
                    success.data.data.forEach((tag) => {
                        tag.label = this.$t(tag.label)
                        this.tags.push(tag)
                    })

                    if (this.tags.length === 1) {
                        this.tag_selected = this.tags[0]
                    }
                })
                .catch((error) => {
                    this.manageError(error)
                })
        },
        openPutUpdateFollowUpDialog(follow_up) {
            this.follow_up = follow_up
            this.isNew = false
            this.is_add_edit_follow_dialog_open = true
            this.date = JSON.parse(follow_up.additional_data)?.date
        },
        openPostAddFollowUpDialog() {
            this.isNew = true
        },
    },
}
</script>
